import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  activityFeedFilterAtom,
  activityFeedAppliableFiltersAtom,
  defaultActivityFeedFilter,
  IActivityFeedFilter,
} from 'atoms';
import FilterPopover, { IFilterForm } from 'components/filter-popover';
import { FILTER_FORM_DEFAULT_VALUES } from './constants';
import { getFilterCount, getFilteredValues } from './utils';

export const ActivityFeedFilter = () => {
  const setFilter = useSetAtom(activityFeedFilterAtom);
  const appliableFilters = useAtomValue(activityFeedAppliableFiltersAtom);
  const [filtersCount, setFiltersCount] = useState<number>(0);

  const filterForm = useForm<IFilterForm>({
    defaultValues: FILTER_FORM_DEFAULT_VALUES,
  });

  const onFilterSubmit = (formValues: IFilterForm) => {
    const filteredValues = getFilteredValues(formValues);

    if (Object.keys(filteredValues)?.length === 0) {
      setFilter(defaultActivityFeedFilter);
      setFiltersCount(0);
      return;
    }

    const filterData: IActivityFeedFilter = {
      phasesIds: filteredValues.phasesIds || null,
      phaseItemsIds: filteredValues.phaseItemsIds || null,
      posterProfileIds: filteredValues.posterProfileIds || null,
      fromDate: filteredValues.fromDate ? filteredValues.fromDate.toISOString() : null,
      toDate: filteredValues.toDate ? filteredValues.toDate.toISOString() : null,
      isPhotoIncluded: filteredValues.isPhotoIncluded ?? null,
      isFileIncluded: filteredValues.isFileIncluded ?? null,
    };

    setFilter(filterData);
    setFiltersCount(getFilterCount(formValues));
  };

  const onFilterClear = () => {
    filterForm.reset(FILTER_FORM_DEFAULT_VALUES);
    setFilter(defaultActivityFeedFilter);
    setFiltersCount(0);
  };

  return (
    <FormProvider {...filterForm}>
      <FilterPopover
        withSwitches={true}
        filtersCount={filtersCount}
        appliableFiltersOverride={appliableFilters}
        onSubmit={onFilterSubmit}
        onReset={onFilterClear}
        isHideButtonLabel={true}
      />
    </FormProvider>
  );
};
